module.exports = __webpack_public_path__ + "images/category_lp/pc/step1_902bde18a759cdb4093b55fa078affea.png";